import { useEffect, useRef } from "react";
import { createChart, type IChartApi, type ISeriesApi } from "lightweight-charts";
import type { Candle } from "../api/markets";

interface Props {
  candles: Candle[];
  height?: number;
}

export function ChartPanel({ candles, height = 360 }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const chartRef = useRef<IChartApi | null>(null);
  const seriesRef = useRef<ISeriesApi<"Candlestick"> | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const chart = createChart(containerRef.current, {
      autoSize: true,
      layout: { background: { color: "#0a0e17" }, textColor: "#cbd2dc" },
      grid: {
        vertLines: { color: "#1a2030" },
        horzLines: { color: "#1a2030" },
      },
      timeScale: { timeVisible: true, secondsVisible: false },
      crosshair: { mode: 1 },
    });
    chartRef.current = chart;
    seriesRef.current = chart.addCandlestickSeries({
      upColor: "#5af2c2",
      downColor: "#ff5c8a",
      borderUpColor: "#5af2c2",
      borderDownColor: "#ff5c8a",
      wickUpColor: "#5af2c2",
      wickDownColor: "#ff5c8a",
    });
    return () => {
      chart.remove();
      chartRef.current = null;
      seriesRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!seriesRef.current) return;
    seriesRef.current.setData(
      candles.map((c) => ({ time: c.t as never, open: c.o, high: c.h, low: c.l, close: c.c })),
    );
  }, [candles]);

  return <div ref={containerRef} style={{ width: "100%", height }} />;
}
